import { render, staticRenderFns } from "./YfPopover.vue?vue&type=template&id=28130740&scoped=true&"
import script from "./YfPopover.vue?vue&type=script&lang=js&"
export * from "./YfPopover.vue?vue&type=script&lang=js&"
import style0 from "./YfPopover.vue?vue&type=style&index=0&id=28130740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28130740",
  null
  
)

export default component.exports